const showItems = (hiddenItems) => {
  hiddenItems.splice(0, 6).forEach(
    elem => elem.classList.remove('hidden')
  )
}

(function () {

  const loadMore = document.getElementById('loadMore')
  const hiddenItems = [...document.querySelectorAll('.recipe-list-sec .hidden')]

  showItems(hiddenItems)

  if (loadMore) {
    if (hiddenItems.length === 0) {
      loadMore.classList.add('hidden')
    }
    else {
      loadMore.addEventListener('click', function (e) {
        e.preventDefault()
        showItems(hiddenItems)

        // hide CTA when no more hidden left
        if (hiddenItems.length === 0) {
          loadMore.classList.add('hidden')
        }

      })
    }
  }

})()
